<template>
  <div class="entries">
    <img src="@/assets/newIndex/u3087swww.png" class="imgs" />
    <div class="tentext">精选评比活动</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.entries {
  width: 1200px;
  height: 100px;
  opacity: 1;
  display: flex;
  justify-content: center;
  background-image: url('http://121.12.125.214:2364/images/%E5%BE%AE%E8%AD%A6%E6%A0%A1/u2369.svg');
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
  }
  .tentext {
    font-size: 48px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    line-height: 100px;
    color: #f6f6f6;
    opacity: 1;
    position: absolute;
    white-space: nowrap;
    // text-shadow: 1px 1px 3px rgb(255 255 255 / 95%);
  }
}
</style>